export default "__VITE_ASSET__DogYZq12__"